/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { isHTMLElement } from "@adapptio/lib-shared";
import { isElementScrollable } from "./isElementScrollable";
import { getParentNode } from "./getParentNode";

const topParentNodeNames = new Set([ "html", "body", "#document" ]);

export function getScrollParent(node: Node): HTMLElement {
	if (topParentNodeNames.has(node.nodeName.toLowerCase())) {
		return node.ownerDocument.body;
	}

	if (isHTMLElement(node) && isElementScrollable(node)) {
		return node;
	}

	return getScrollParent(getParentNode(node));
}
